<loading-indicator
  *ngIf="!mailDeviceContext && !mailDeviceContextError"
  [label]="mailDeviceGettingContextInProgress"
  [spinnerNextToText]="true"
></loading-indicator>

<div
  *ngIf="mailDeviceContext"
  data-testId="mail-device-page">


  <form class="card-body">
    <div
      data-testId="mail-device-measurement-details"
      *ngIf="feature514Released"
    >
      <div>
        <span class="strong me-2">{{ "mailDeviceMeasurementDetailsHospitalNameLabel" | localize}}:</span>
        <span>{{ mailDeviceContext.homePatientFormContext.hospitalName }}</span>
      </div>
      <div>
        <span class="strong me-2">{{ "mailDeviceMeasurementDetailsCodeLabel" | localize}}:</span>
        <span>{{ mailDeviceContext.homePatientFormContext.code }}</span>
      </div>
      <div>
        <span class="strong me-2">{{ "mailDeviceMeasurementDetailsUniqueIdLabel" | localize}}:</span>
        <span>{{ mailDeviceContext.homePatientFormContext.uniqueId }}</span>
      </div>

    </div>

    <div class="my-3">
      <button
        data-testId="print-mailing-info-button"
        class="btn btn-secondary"
        (click)="printMailingInfo()"
      >
        {{ "mailingConfirmationPrintMailingInfoButtonLabel" | localize }}
      </button>

      <action-button
        class="ms-2"
        [actionInProgress]="printingInProgress"
        buttonLabel="printHomePatientDataFormButtonLabel"
        actionInProgressLabel="printHomePatientDataFormButtonInProgressLabel"
        (buttonClick)="printHomePatientDataForm()"
        [testId]="'print-home-patient-data-form-button'"
      ></action-button>
    </div>

    <form-field [config]="formConfig.deviceSerialNumber"></form-field>

    <p>
      <action-button
        [actionInProgress]="confirmingInProgress"
        buttonLabel="mailingConfirmationButtonLabel"
        actionInProgressLabel="mailingConfirmationButtonInProgressLabel"
        (buttonClick)="confirmDeviceMailing()"
        [testId]="'mailing-confirmation-button'"
        [buttonDisabled]="!canConfirmMailDevice()"
      >
      </action-button>
    </p>
  </form>

</div>

<div
  *ngIf="mailDeviceContextError"
  class="alert alert-danger"
>
  {{ mailDeviceContextError | localize }}
</div>

